import { useCallback, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import NoneAnchor from 'components/NoneAnchor'
import {
  CHART_OPTION_ADD_GROUPS,
  CHART_OPTION_GROUPS,
  CHART_OPTION_PIXEL_AND_SDK_GROUPS,
  CHART_OPTION_TALK_CHANNEL_GROUPS,
  ChartOptions,
} from 'features/dashboard/info/chart/chartConstants'
import classNames from 'classnames'
import useOutsideClick from 'utils/hooks/useOutsideClick'
import { useDispatch, useSelector } from 'react-redux'
import { setMetricColumn } from './dashboardChartSlice'
import { getSummaryText } from './chartUtil'
import Loading from '../../../../components/loading/Loading'

const Options = ({ options, selected, onClick }) =>
  options.map(option => (
    <li
      key={option.value || 'default'}
      className={option.value === selected ? 'on' : ''}>
      <NoneAnchor className="link_option" onClick={() => onClick(option)}>
        {option.text || option.value}
      </NoneAnchor>
    </li>
  ))

const ChartSelectBox = ({ icon, index }) => {
  const dispatch = useDispatch()
  const { metricColumns, summary, isLoading } = useSelector(
    state => state.dashboard.chart
  )
  const metricId = useMemo(() => metricColumns[index], [metricColumns, index])
  const selectedOption = useMemo(
    () =>
      ChartOptions.find(option => option.value === metricId) || ChartOptions[0],
    [metricId]
  )
  const summaryText = useMemo(
    () => getSummaryText(summary[metricId]),
    [summary, metricId]
  )
  const [isOpen, setOpen] = useState(false)
  const close = () => {
    setOpen(false)
  }

  const ref = useOutsideClick(close)

  const handleSelectClick = () => {
    setOpen(!isOpen)
  }

  const handleOptionClick = useCallback(
    option => {
      dispatch(
        setMetricColumn({
          index,
          metricId: option.value,
        })
      )
      close()
    },
    [dispatch, index]
  )

  return (
    <div className={classNames('opt_select', { opt_open: isOpen })} ref={ref}>
      <div className="screen_out">선택상자</div>
      <span className="screen_out">선택내용 : </span>
      <NoneAnchor className="link_selected" onClick={handleSelectClick}>
        {icon}
        {selectedOption.text || selectedOption.value}
        {isLoading ? (
          <Loading size="small" style={{ height: 18 }} />
        ) : (
          <span className="fw_bold">{summaryText}</span>
        )}
      </NoneAnchor>
      <span className="ico_arr" />
      <div className="screen_out">선택옵션</div>
      <div className="opt_list">
        <strong className="tit_option">{CHART_OPTION_GROUPS.title}</strong>
        <ul className="list_opt2">
          <Options
            options={CHART_OPTION_GROUPS.options}
            selected={metricId}
            onClick={handleOptionClick}
          />
        </ul>
        <strong className="tit_option">{CHART_OPTION_ADD_GROUPS.title}</strong>
        <ul className="list_opt2">
          <Options
            options={CHART_OPTION_ADD_GROUPS.options}
            selected={metricId}
            onClick={handleOptionClick}
          />
        </ul>
        <strong className="tit_option">
          {CHART_OPTION_PIXEL_AND_SDK_GROUPS.title}
        </strong>
        <ul className="list_opt2">
          <Options
            options={CHART_OPTION_PIXEL_AND_SDK_GROUPS.options}
            selected={metricId}
            onClick={handleOptionClick}
          />
        </ul>
        <strong className="tit_option">
          {CHART_OPTION_TALK_CHANNEL_GROUPS.title}
        </strong>
        <ul className="list_opt2">
          <Options
            options={CHART_OPTION_TALK_CHANNEL_GROUPS.options}
            selected={metricId}
            onClick={handleOptionClick}
          />
        </ul>
      </div>
    </div>
  )
}

ChartSelectBox.propTypes = {
  icon: PropTypes.node,
  index: PropTypes.number.isRequired,
}

export default ChartSelectBox
